import { BigNumber } from "bignumber.js";
import { cloneDeep } from "lodash";
import FooterControl from "@/components/FooterControl.vue";
import HisAutocompleteSuggestions from "@/components/HisAutocompleteSuggestions/index.vue";
import scrollbar from "@/mixins/scrollbar";
import payDialog from "../pay/index.vue";
import { validatePhoneNoRequired, validatePhone, checkIDCard } from "@/utils/validate/elementMethod";
import { REG_P_INT, REG_AMT, REG_T_ZEAR } from "@/utils/validate/regExp";
import { cityCode } from "@/utils/cityPicker/cityCode";
import receiptPrint from "@/components/receiptPrint/index.vue";
import { getLodop } from "@/plugins/LodopFuncs";
import noPrintTips from "@/components/noPrintTips.vue";
import continuousDialog from "@/components/continuousDialog/index.vue";
import SearchPopoverCommon from '@/components/search-popover-common.vue';
import { addMemberConfig, popoverAttrs, selectAttrs, addMemberFormAttrs } from "@/views/outPatient/medicalRecord/static-data.js";
import selectInputCommon from "@/components/select-input-common.vue";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

const autocompleteScroll = {
  bind (el, binding, vnode) {
    // 此处为了简单，直接判断触底了
    function handleScroll (e) {
      let isBottom =
          e.target.clientHeight + e.target.scrollTop == e.target.scrollHeight
      if (isBottom && !vnode.context.loading) {
        binding.value()
      }
    }
    // 监听滚动
    let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap')
    el.__handleScroll__ = handleScroll
    el.__wrapDom__ = wrapDom
    wrapDom.addEventListener('scroll', handleScroll, false)
  },

  unbind (el, binding, vnode) {
    console.log('unbind')
    // 解除事件监听
    el.__wrapDom__.removeEventListener('scroll', el.__handleScroll__, false)
  }
}

export default {
  name: "sale-drug",
  mixins: [scrollbar],
  components: {
    selectInputCommon,
    FooterControl,
    HisAutocompleteSuggestions,
    payDialog,
    receiptPrint,
    noPrintTips,
    continuousDialog,
    SearchPopoverCommon
  },
  data () {
    const checkAge = (rule, value, callback) => {
      if (this.ageForm.showYear && !this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.patient.year === "") {
          callback();
        }
        if (!REG_T_ZEAR.test(this.patient.year)) {
          callback(new Error("请输入正确的年龄"));
        }
      }
      if (this.ageForm.showYear && this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.patient.year === "" && this.patient.month === "") {
          callback();
        }
        if (this.patient.year && !REG_T_ZEAR.test(this.patient.year)) {
          callback(new Error("请输入正确的年龄"));
        }
        if (this.patient.month && !REG_T_ZEAR.test(this.patient.month)) {
          callback(new Error("请输入正确的年龄"));
        }
      }
      if (!this.ageForm.showYear && this.ageForm.showMonth && this.ageForm.showDay) {
        if (this.patient.month === "" && this.patient.day === "") {
          callback();
        }
        if (this.patient.month && !REG_T_ZEAR.test(this.patient.month)) {
          callback(new Error("请输入正确的年龄"));
        }
        if (this.patient.day && !REG_T_ZEAR.test(this.patient.day)) {
          callback(new Error("请输入正确的年龄"));
        }
      }
      if (this.patient.year >= 150) {
        callback(new Error("年龄在0-150之间"));
      }
      callback();
    };
    return {
      isDialogShow: false, // 是否显示医保支付弹窗
      drugDiscounts: false,
      additionDiscounts: false,
      examDiscounts: false,
      qvalue: "",
      centerDialogVisible: false,
      doctorId: "", // 医生ID
      checked: "",
      ageForm: {
        showYear: true,
        showMonth: false,
        showDay: false
      },
      ruleForm: {
        name: "",
        drugType: "1",
      },
      rules: {
        patientName: [{ required: true, message: "请输入姓名" }],
        gender: [{ required: true, message: "请选择性别" }, { required: true, message: "请选择性别", trigger: "change" }],
        age: [{ required: true, message: "请输入年龄" }, { required: true, validator: checkAge, trigger: "change" }],
        phoneNo: [{ required: true, message: "请输入手机号" }, { required: true, validator: validatePhone, trigger: "change" }],
        idCardNo: [{ validator: checkIDCard, trigger: "change" }]
      },
      options: [],
      value: "",
      hasExam: false,
      hasAddition: false,
      paitentDisable: false, // 控制姓名不能修改
      patient: {
        patientName: "",
        gender: 1,
        year: "",
        month: '',
        day: 0,
        phoneNo: "",
        idCardNo: "",
        hiMedType: 1,//医疗类别
        doctorIds: ''
      },
      orderExam: {
        discountAmt: 0,
        receivableAmt: 0,
        items: [
          {
            examId: "",
            count: 1,
            examName: "",
            currentValue: ""
          }
        ]
      },
      orderAddition: {
        discountAmt: 0,
        receivableAmt: 0,
        items: [{ amtName: "", salePrice: 0 }]
      },
      orderPrescription: {
        discountAmt: 0,
        receivableAmt: 0,
        items: []
      },
      examOptions: [], // 检查治疗项列表
      wipeAmt: 0,
      dialogVisible: false, // 支付窗口
      serverTotal: null,
      orderId: 0,
      orderNo: "",//订单号
      couponDiscountAmt: 0, // 优惠券金额
      hasCoupon: false,
      couponId: "",
      couponType: 0,
      couponVal: {},
      doctorList: [], // 诊所医生列表
      scriptList: {},
      realName: "", // 医生名称
      review: true, // 是否开启打印预览模式
      printShow: false,
      debtorInfo: {
        // 传入子组件默认的欠费人信息
        name: "",
        phone: ""
      },
      examQuery: {
        currentPage: 1,
        pageSize: 10
      }, // 检查治疗项分页查询
      totalExam: 0, // 检查治疗项分页总数
      checkedExam: [], // 选中的检查治疗项
      sellDrugWithoutInventory: 1,// 是否开启无库存售药 1：是 0：否
      settlementObj: {},//结算流程
      mdtrtId: '',//就诊id
      prohibitFlag: false,//禁止使用医保支付
      PatientListPages: 1, //患者信息列表总页数
      PatientListPage: 1, //患者信息列表页码
      isSellPriceUpdate: true, //零售价是否支持修改
      addMemberPopoverShow: false, //
      addMemberForm: {},
      addMemberConfig,
      popoverAttrs,
      selectAttrs,
      addMemberFormAttrs,
      examDialogVisible: false,
      examListAll: [], // 所有检查治疗项
      // 选择的列表
      diagnosisExamList  : {
        discountAmt: 0,
        receivableAmt: 0,
        items: []
      },
      selectList: [],
      oneTreeIndex: 0,
      twoTreeIndex: 0,
      // 二级树
      twoTreeRow: [],
      // 内容区
      contentTree: [],
      addExamDrug: '',
      diagnosisExamDiscounts: false,
    };
  },
  methods: {
    // 获取零售价是否支持修改
    async getSellPriceUpdate () {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType: 15, })
      this.isSellPriceUpdate = !res.sellPriceUpdate
    },
    async getChargesConfig () {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType: 12, })
      // console.log(res,'res');
      this.patient.hiMedType = res.charges || 1

    },
    initDrug () {
      const array = [
        { drugName: "", isWarning: false, currentValue: "" },
        { drugName: "", isWarning: false, currentValue: "" },
        // { drugName: "", isWarning: false, currentValue: "" }
        // { drugName: '', isWarning: false, currentValue: '' },
        // { drugName: '', isWarning: false, currentValue: '' },
      ];
      this.orderPrescription.items = this.orderPrescription.items.concat(array);
    },
    openCheckLine () {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.examOptions.clearSelection();
        this.hasExam = true;
      });
    },
    querySearch (str, cb) {
      this.$api.drugControl
          .drugsNameList({
            drugName: str
          })
          .then(res => {
            res.drugList = res.drugList.map(item => {
              const drug = {
                drugName: item.drugName,
                specification: item.specification,
                manufacturer: item.manufacturer,
                drugId: item.id
              };
              return drug;
            });
            cb(res.drugList);
          });
    },
    queryDrug (str, cb, index) {
      this.$set(this.orderPrescription.items, index, {
        drugName: str,
        isWarning: false,
        currentValue: ""
      });
      // this.orderPrescription.items[index] = { drugName: str, isWarning: false, currentValue: '' };
      this.$api.drugControl
          .getDrugByName({ drugName: str })
          .then(res => {
            // console.log(res, "res");
            if (res.length > 0) {
              res.push({ isHeader: true, label: '' })
            }
            cb(res);
          })
          .catch(() => {
            cb([]);
          });
    },
    // 通过药品ID获取药品详情 ======== 药品入口
    selectHandleDrug (drugId, index) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.orderPrescription.items.map(item => item.drugId).indexOf(drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: "warning",
          message: "该药已在列表中！"
        });
        return;
      }
      // 初始化药品数据内容
      const initSalePrice = (list, status) => {
        const arr = list.map(item => {
          const sale = item.sale[item.sale.length - 1]; // 取最后一个单位
          // 判断 batches 是否为空为空就给他 ’--‘
          const batches = item.batches.map(it => {
            const batche = { ...it };
            if (!it.batchNo) batche.batchNo = "--";
            return batche;
          });
          const obj = {
            ...item,
            saleUnit: sale.unitName,
            salePrice: sale.drugSalePrice,
            currentValue: status === "noInstock" ? "" : item.drugName, // 在无库存的时候当前不给选中的值 || 当前选中的值
            batches,
            drugBatchNo: batches[0].batchNo, // 默认给第一批号
            initPopover: false, // 初始化popover
            isInventoryWarning: false // 初始化 库存提示的icon
          };
          return obj;
        });
        return arr;
      };
      this.$api.feeDispense.sellDrugDetail({ drugId }).then(res => {
        // console.log(res, "res444");
        const response = res;
        let status = "";
        if (res[0].batches.length === 0) {
          // 当前item 提示无库存
          this.orderPrescription.items[index].currentValue = "";
          response[0].tipContentDrug = "该药没有库存！";
          status = "noInstock";
          response[0].batches.push({ batchNo: "", inventory: "" }); // 允许售卖无库存添加初始化批次值
          if (this.sellDrugWithoutInventory) {
            this.$message({
              type: "warning",
              message: "该药没有库存！"
            });
          } else {
            this.$message({
              type: "error",
              message: "该药没有库存！"
            });
            return; // 不允许售卖无库存药品
          }
        }
        if (res[0].sale.length === 0) {
          this.orderPrescription.items[index].currentValue = "";
          this.orderPrescription.items[index].tipContentDrug = "药品没有设置零售价，无法收费！";
          this.$message({
            type: "warning",
            message: "药品没有设置零售价，无法收费！"
          });
          return;
        }
        const drugList = initSalePrice(response, status);
        // 当前处理只有一种药的情况 常规情况
        const [drug] = drugList;
        // console.log(drug);

        this.$set(this.orderPrescription.items, index, drug);
        const selectedDrugNum = this.orderPrescription.items.filter(item => !item.drugId).length;
        if (selectedDrugNum === 0)
          this.orderPrescription.items.push({ drugName: "", currentValue: "" });
        this.$nextTick(() => {
          document
              .querySelectorAll(".suggestions-input")
              [index + 1].querySelector("input")
              .focus();
        });
      });
    },
    // 改变药品单位获取药品价格
    changePrice (e, index) {
      const drugSale = this.orderPrescription.items[index].sale.find(item => item.unitName === e);
      this.orderPrescription.items[index].salePrice = drugSale.drugSalePrice;
      this.orderPrescription.items[index].unitName = drugSale.unitName;
    },
    // 删除单个药品
    delDrug (index) {
      if (this.orderPrescription.items.length === 1) return;
      this.orderPrescription.items.splice(index, 1);
    },
    dosageChange (item, e, index) {
      console.log('index: ', index);
      console.log('e: ', e);
      console.log('item: ', item);
      // 开药量修改 判断是否符合库存
      const { ratio } = item.sale.find(it => it.unitName === item.saleUnit);
      this.orderPrescription.items[index].isInventoryWarning = e * ratio > item.inventoryCount;
      // 从后台获取多个药品批次的药事件
      // console.log(item);
    },
    // 药品单项合计金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return "0.000";
      return BN(price)
          .multipliedBy(num)
          .toFixed(2);
    },
    examNameItemAmt (price, num) {
      // console.log(price, num);
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return "0.000";
      return BN(price)
          .multipliedBy(num)
          .toFixed(2);
    },
    // 获取患者信息列表
    async getPatientList (queryString) {
      this.patient.patientName = queryString || this.patient.patientName
      let res = await this.$api.outPatient.listclinicPatientByNameOrPhone({ patientName: this.patient.patientName, page: this.PatientListPage, pageSize: 10 })
      console.log('res: ', res);
      this.PatientListPages = res.pages
      let list = [];
      list = res.records.map(item => ({ ageCom: `${item.age}${item.ageType}`, ...item }));
      return list
    },
    // 获取患者信息
    async queryPatient (patientName, cb) {
      // this.$api.outPatient.getHospitalPatient({ patientName })
      let list = [];
      list = await this.getPatientList(patientName);
      if (list.length > 0) {
        list.push({ isHeader: true, label: '' })
      }
      cb(list);
    },

    // 分页加载
    async patientHandleScroll () {
      // 限制翻页限度
      if (this.PatientListPage > this.PatientListPages) {
        return
      }

      this.PatientListPage++

      let list = await this.getPatientList(this.patient.patientName)

      this.$refs['patientListAutocomplete'].$data.suggestions.push(...list)
    },

    handleSelectPatient (patient) {
      console.log(patient,'123123213')
      this.patient = {
        ...this.patient,
        ...patient, year: patient.age || patient.year,
      };
      this.dayHandle();
      this.paitentDisable = true;
    },
    clearPatient () {
      this.paitentDisable = false;
      this.patient = {
        patientName: "",
        gender: 1,
        year: "",
        month: '',
        day: 0,
        phoneNo: "",
        idCardNo: ""
      };
      this.ageForm = {
        showYear: true,
        showMonth: false,
        showDay: false
      };
    },
    // 添加附加费用
    addAddition () {
      this.orderAddition.items.push({ amtName: "", salePrice: 0 });
    },
    // 删除一条附加费用
    delAddition (index) {
      if (this.orderAddition.items.length === 1) {
        this.$set(this.orderAddition.items, index, {
          amtName: "",
          salePrice: 0
        });
        return;
      }
      this.orderAddition.items.splice(index, 1);
    },
    // 获取检查治疗项
    getExamAll () {
      this.$api.clinicManagement.listPagedExam(this.examQuery).then(res => {
        this.examOptions = res.examList.map(item => ({
          ...item,
          cost: item.examCost
        }));
        this.totalExam = res.totalSize || 0;
      });
    },
    // 检查治疗项翻页
    pageChangeExam (e) {
      this.examQuery.currentPage = e;
      this.getExamAll();
    },
    // 勾选常用处方模板
    handleExamChange (val) {
      this.checkedExam = val;
    },
    // 选择检查治疗项
    selectExamList () {
      this.checkedExam.forEach(item => {
        this.orderExam.items.push({
          examId: item.examId,
          examName: item.examName,
          salePrice: item.examPrice,
          cost: item.examCost,
          count: 1,
          initName: item.examName, // 初始化 组件内部的 currentvalue 值 为了不让组件显示感叹号提示
          hiExamCode: item.hiExamCode,
          hiExamName: item.hiExamName,
        });
      });
      this.checkedExam = []; // 清空选项
      this.centerDialogVisible = false;
    },
    // 删除检查治疗项
    delExamItem (index) {
      if (this.orderExam.items.length === 1) {
        // if (this.orderExam.items.length === 1 || !this.orderExam.items[index].examId) {
        this.$set(this.orderExam.items, index, {
          examId: "",
          count: 1,
          examName: "",
          currentValue: ""
        });
        return;
      }
      // if (this.orderExam.items.length === 1 || !this.orderExam.items[index].examId) return;
      this.orderExam.items.splice(index, 1);
    },
    // 关键词搜索
    queryExam (name, cb) {
      this.$api.outPatient
          .getExamList({ examName: name })
          .then(res => {
            const result = res.map(item => ({ ...item, cost: item.examCost }));
            cb(result);
          })
          .catch(() => {
            cb([]);
          });
    },
    handleSelectExam (event, index) {
      // console.log(event, 'event');
      this.$set(this.orderExam.items, index, {
        ...event,
        count: 1,
        salePrice: event.examPrice,
        currentValue: event.examName
      });
      const selectedExam = this.orderExam.items.filter(item => !item.examId).length;
      if (selectedExam === 0) {
        this.orderExam.items.push({ examName: "", currentValue: "" });
      }
    },
    // 获取优惠券
    getCoupon () {
      this.$api.member.coupon({ id: this.couponId }).then(res => {
        this.couponType = res.paramType;
        this.couponVal = JSON.parse(res.paramValue);
      });
    },
    // 提交收费
    async confirm () {
      await this.$refs.ruleForm.validate()
      await this.$nextTick();
      const orderPrescription = cloneDeep(this.orderPrescription);
      orderPrescription.items = orderPrescription.items.filter(item => item.drugId);
      let orderExam = cloneDeep(this.orderExam);
      orderExam.items = orderExam.items.filter(item => item.examId);
      orderExam.receivableAmt = this.examAmt;
      // 判断用户有没有选择添加治疗项
      if (!this.hasExam) {
        orderExam = {
          discountAmt: 0,
          receivableAmt: 0,
          items: []
        };
      }
      let orderItemDiagnosis = cloneDeep(this.diagnosisExamList);
      orderItemDiagnosis.items = orderItemDiagnosis.items.filter(item => item.itemId);
      orderItemDiagnosis.receivableAmt = this.examListAmt;
      // 判断用户有没有选择添加诊疗项目
      console.log(this.hasDiaanosisExam)
      // if (!this.hasDiaanosisExam) {
      //   orderItemDiagnosis = {
      //     discountAmt: 0,
      //     receivableAmt: 0,
      //     items: []
      //   };
      // }
      let orderAddition = cloneDeep(this.orderAddition);
      orderAddition.items = orderAddition.items.filter(item => item.amtName);
      this.orderAddition.receivableAmt = this.addtionAmt;

      // 判断用户有没有选择添加附加费用
      if (!this.hasAddition) {
        orderAddition = {
          discountAmt: 0,
          receivableAmt: 0,
          items: []
        };
      }
      // 药品列表 检查治疗项 附加费用的优惠是否为空字符串 如果为空字符串则给
      if (!orderPrescription.discountAmt) orderPrescription.discountAmt = 0;
      if (!orderAddition.discountAmt) orderAddition.discountAmt = 0;
      if (!orderExam.discountAmt) orderExam.discountAmt = 0;
      if (!orderItemDiagnosis.discountAmt) orderItemDiagnosis.discountAmt = 0;

      const req = {
        orderAddition,
        orderExam,
        orderItemDiagnosis,
        orderPrescription,
        actualReceivableAmt: this.actualReceivableAmt,
        receivableAmt: this.totalAmt || 0,
        discountAmt: this.offer || 0,
        wipeAmt: this.wipeAmt || 0,
        couponDiscountAmt: this.couponAmt || 0,
        couponCode: this.couponCode,
        doctorIds: this.doctorIds
      };
      // 验证药品信息填写内容 名称 | 数量
      const scriptNameValidate = orderPrescription.items.some(
          item => item.currentValue !== item.drugName && !item.tipContentDrug
      );
      // 药品库存数量
      const scriptInventoryValidate = orderPrescription.items.some(item => item.isInventoryWarning);
      const scriptNameInventoryvalidate = orderPrescription.items.some(
          item => item.currentValue !== item.drugName && item.tipContentDrug === "该药没有库存！"
      );
      const scriptNumberValidate = orderPrescription.items.some(
          item => !REG_P_INT.test(item.dosage)
      );
      const ExamNameValidate = orderExam.items.some(item => item.isWarning);
      const ExamNumberValidate = orderExam.items.some(item => !REG_P_INT.test(item.count));

      const ExamNumValidate = orderItemDiagnosis.items.some(item => !item.totalNum);
      const ExamPriceValidate = orderItemDiagnosis.items.some(item => !item.totalPrice);

      const addAmtValidate = orderAddition.items.some(item => !REG_AMT.test(item.salePrice));
      if (scriptNameValidate) {
        return this.$message.warning("部分药品没有录入您的药品信息管理中！")

      }
      if (ExamNameValidate) {
        return this.$message.warning("部分检查治疗项不匹配！");
      }
      if (scriptNumberValidate) {
        return this.$message.warning("部分药品数量输入不正确！")
      }
      if (ExamNumberValidate) {
        return this.$message.warning("部分检查治疗项次数输入不正确！");
      }
      if (addAmtValidate) {
        return this.$message.warning("部分附加费用输入不正确！");
      }
      if (ExamNumValidate) {
        return this.$message.warning("诊疗项目部分总量输入不正确！");
      }
      if (ExamPriceValidate) {
        return this.$message.warning("诊疗项目部分总价格输入不正确！");
      }
      if (this.scriptAmt < orderPrescription.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        return this.$message.warning("药品优惠输入不正确！")
      }

      if (this.examAmt < orderExam.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        return this.$message.warning("检查治疗项优惠输入不正确！")
      }

      if (this.examListAmt < orderItemDiagnosis.discountAmt ) {
        return this.$message.warning("检查治疗项优惠输入不正确！")
      }

      if (this.addtionAmt < orderAddition.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        return this.$message.warning("附加费用优惠输入不正确！")
      }
      if (parseFloat(this.totalAmt) < parseFloat(this.totalDiscount) || !REG_AMT.test(this.wipeAmt)) {
        return this.$message.warning("抹零优惠输入不正确！")
      }
      // 有患者信息时需要验证内容
      // 打印拦截如果没有安装打印插件
      const LODOP = getLodop();
      if (!LODOP && this.isPrint) {
        this.printShow = true;
        return;
      }
      // 打印数据输入
      // 修改数据结构

      const exam = req.orderExam;
      if (exam) {
        exam.items = exam.items.map(item => ({ ...item, drugName: item.examName }));
      }
      // 诊疗项目  转换
      const diagnosisExam = req.orderItemDiagnosis;
      if (diagnosisExam) {
        diagnosisExam.items = diagnosisExam.items.map(item => ({ ...item}));
      }
      const addition = req.orderAddition;
      if (addition) {
        addition.items = addition.items.map(item => ({ ...item, drugName: item.amtName }));
      }

      this.scriptList = {
        saleDrugPrescriptionList: req.orderPrescription, // 成药
        orderExam: exam, // .map(item => ({ ...item, drugName: item.examName })), // 检查治疗项
        orderDiagnosisExam: diagnosisExam, // .map(item => ({ ...item, drugName: item.examName })), // 检查治疗项
        orderAddition: addition, // .map(item => ({ ...item, drugName: item.amtName })), // 附加费用
        realName: this.realName, // 给组件传入售药的医生
        receivableAmt: req.receivableAmt, // 合计
        totalDiscountAmt: BN(req.discountAmt).plus(req.wipeAmt).plus(req.couponDiscountAmt).toFixed(2), // 总优惠
        actualReceivableAmt: req.actualReceivableAmt // 实收
      };
      this.scriptList.patientName = this.patient.patientName;
      this.scriptList.realName = this.patient.patientName;
      // console.log(this.scriptList);
      // 有患者信息
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 支付的时候传入默认的欠费人信息
          this.debtorInfo = { name: this.patient.patientName, phone: this.patient.phoneNo };
          // console.log(this.debtorInfo);
          // 年龄处理 如果是空字符串转 0
          if (this.patient.year === "") this.patient.year = 0;
          if (this.patient.month === "") this.patient.month = 0;
          if (this.patient.day === "") this.patient.day = 0;
          req.patient = this.patient; // 患者信息
          req.hiMedType = this.patient.hiMedType //医疗类别
          req.doctorIds = req.patient.doctorIds
          if (scriptInventoryValidate || scriptNameInventoryvalidate) {
            // console.log(this.sellDrugWithoutInventory);
            if (!this.sellDrugWithoutInventory) {
              this.$message.error('部分药品库存不足！')
            } else {
              this.$confirm("部分药品库存不足, 是否继续?", "友情提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                this.request(req);
              }).catch(() => { });
            }
            return;
          }
          this.request(req);
        }
      });
    },
    request (req) {
      if(req.orderItemDiagnosis.items && req.orderItemDiagnosis.items.length > 0) {
        req.orderItemDiagnosis.items.forEach((item)=>{
          if(item.totalPrice) {
            item.receivableAmt = item.totalPrice
            item.actualPrice = item.totalPrice
          }
        })
      }
      console.log(req)
      this.$api.feeDispense.sellDrug(req).then(res => {
        // console.log(res, "res");
        this.orderId = res.orderId;
        this.orderNo = res.orderNo
        this.serverTotal = res.actualReceivableAmt;
        // this.dialogVisible = true;
        this.$router.push({
          path: "/fee/waitFeedetail",
          query: { id: res.orderId, orderType: 2 }
        });
      })
      // .then(() => {  this.settlementProcess();      });
    },
    // 结算流程
    async settlementProcess () {
      let res = await this.$api.newInsurance.settlementProcessAPI({ orderNo: this.orderNo })
      // console.log(res,'结算流程');
      if (res.data.code == 200 && res.data.data != null) {
        this.settlementObj = res.data.data
        const { outpatientVisits } = this.settlementObj
        // console.log(outpatientVisits,'outpatientVisits')
        if (outpatientVisits != null) {
          this.mdtrtId = outpatientVisits.mdtrtId
        }
      }
      if (res.data.code == 1100) {
        this.prohibitFlag = true
      }
    },
    // 支付结束清空数据重新开始
    complated () {
      // 打印小票
      this.print();
      this.$refs.ruleForm.resetFields();
      this.hasExam = false;
      this.hasAddition = false;
      this.orderPrescription = { discountAmt: 0, receivableAmt: 0, items: [] };
      this.orderExam = { discountAmt: 0, receivableAmt: 0, items: [{ examId: "", count: 1, examName: "" }] };
      this.orderAddition = { discountAmt: 0, receivableAmt: 0, items: [{ amtName: "", salePrice: 0 }] };
      this.initDrug();
      this.dialogVisible = false;
      this.couponDiscountAmt = 0; // 优惠券金额
      this.wipeAmt = 0; // 抹零金额重置为0
      this.hasCoupon = false;
      this.couponId = "";
      this.couponVal = {};
      // 初始化用户信息
      this.patient = { patientName: "", gender: 1, year: "", month: 0, day: 0, phoneNo: "", idCardNo: "" };
      this.paitentDisable = false;
      this.ageForm.showYear = true;
      this.ageForm.showMonth = false;
      this.ageForm.showDay = false;
    },
    // 获取医生信息
    // getDoctor () {
    //   this.$api.outPatient.getHospitalDoctor().then(res => {
    //     this.doctorList = res;
    //     console.log('res: ', res);
    //     // 先做默认第一个 后期本地存储一下
    //     this.doctorIds = res[0].doctorId;
    //     this.realName = res[0].realName;
    //   });
    // },
    // 打印小票
    print () {
      if (!this.isPrint) return;
      this.$refs.receiptPrint.print();
    },
    // 判断当前输入药品名是否来自药品库
    checkDrugName (name, id) {
      if (name === "" || id) return false;
      return true;
    },
    // 清空检查治疗项id和价格
    checkDrugExam (index) {
      this.orderExam.items[index].examId = "";
      this.orderExam.items[index].salePrice = "0.00";
    },
    // 开药量输入框焦点事件清空数量
    dosageFocusHandle (index) {
      this.orderPrescription.items[index].dosage = "";
    },
    // 检查治疗项输入框焦点事件清空数量
    countFocusHandle (index) {
      this.orderExam.items[index].count = "";
    },
    // 年龄处理
    yearHandle () {
      const val = this.patient.year;
      if (val < 5 && val > 0) {
        this.ageForm.showMonth = true;
      }
      if (val === 0) {
        this.ageForm.showYear = false;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = true;
      }
      if (val >= 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = false;
        this.ageForm.showDay = false;
        // this.patient.month = 0;
        this.patient.day = 0;
      }
      if (this.patient.year > 0 && this.patient.year < 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = false;
        this.patient.day = 0;
      }
    },
    monthHandle () {
      const val = this.patient.month;
      if (val >= 12) {
        const month = val % 12;
        const year = parseInt(val / 12);
        this.patient.year = this.patient.year + year;
        this.patient.month = month;
      }
      this.yearHandle();
    },
    dayHandle () {
      const val = this.patient.day;
      if (val >= 30) {
        const day = val % 30;
        const month = parseInt(val / 30);
        this.patient.month = this.patient.month + month;
        this.patient.day = day;
      }
      this.monthHandle();
      this.yearHandle();
    },
    // 获取诊所基础功能配置
    async getHospitalConfig () {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType: 10 })
      this.sellDrugWithoutInventory = res.sellDrugWithoutInventory;
    },
    insurancePayment () {
      this.isDialogShow = true;
    },
    handleClose () {
      this.isDialogShow = false;
    },
    async handleSettlementProcess () {
      let res = await this.$api.newInsurance.settlementProcessAPI({ orderNo: this.orderNo, })
      if (res.data.code == 200 && res.data.data != null) {
        this.$set(this, 'settlementObj', res.data.data)
        console.log('this.settlementObj: ', this.settlementObj);
      }
    },
    // 获取获取该登录下所有医生
    async getDoctorList () {
      let params = { costType: this.patient.hiMedType }
      if (this.countInfo.isAdmin != 1) {
        params.doctorId = this.countInfo.doctorId
      }
      let res = await this.$api.outPatient.getDoctorList(params)
      this.doctorList = res
      if (!this.patient.doctorIds) {
        let obj = res.length > 0 ? res.find(item => item.key && item.key.indexOf(this.countInfo.doctorId) != -1) : {}
        this.patient.doctorIds = obj ? obj.key : ''
      }
    },
    hiMedTypeChange () {
      this.patient.doctorIds = ''
      this.getDoctorList()
    },
    addMember () {
      this.addMemberPopoverShow = true
    },
    // 递归循环获取省市区
    getArea (config, code) {
      let name = ''
      for (let i = 0; i < config.length; i++) {
        if (config[i].value == code) {
          name = config[i].label
          return name
        } else {
          if (config[i].children && config[i].children.length > 0) {
            name = this.getArea(config[i].children, code)
            return name
          }
        }
      }
      return name
    },
    async cancelAddMember () {
      this.addMemberForm = {}
      await this.$nextTick()
      await this.$refs.SearchPopoverCommon.$refs.addMemberFormRef.resetFields()
      this.addMemberPopoverShow = false
    },
    async addMemberSubmit () {
      try {
        let form = cloneDeep(this.addMemberForm);
        if (form.attr && form.attr.length > 0) {
          form.provinceCode = this.addMemberForm.attr[0]
          form.province = await this.getArea(cityCode, this.addMemberForm.attr[0])
          form.cityCode = this.addMemberForm.attr[1]
          form.city = this.getArea(cityCode, this.addMemberForm.attr[1])
          form.districtCode = this.addMemberForm.attr[2]
          form.district = await this.getArea(cityCode, this.addMemberForm.attr[2])
        }
        console.log('form: ', form);
        await this.$refs.SearchPopoverCommon.$refs.addMemberFormRef.validate()
        let res = await this.$api.member.insertPatient(form)
        this.cancelAddMember()
        this.$message.success('新增患者成功');
      } catch (error) {

      }
    },
    // 载入诊疗项目
    loadExam (type) {
      this.examDialogVisible = true;
      this.examQuery.keyword = "";
      this.getHospitalExamList(type);
    },
    // 添加检查治疗项
    addExamItem (row) {
      let flag = this.selectList.findIndex(e=>e.itemId === row.itemId)
      console.log('flag',flag)
      if(flag === -1) {
        this.selectList.push(row)
      }else {
        this.selectList.splice(flag,1)
      }
    },
    delExamItemNew(row) {
      let index = this.diagnosisExamList.items.findIndex(e=>e.itemId === row.itemId)
      if(index !== -1) {
        this.diagnosisExamList.items.splice(index, 1)
      }
    },
    changeExamItem(type,itemType,index,rows) {
      console.log(type,itemType,index,rows)
      switch (type) {
        case 22 : // 检查
        case 21 : // 检验
        case 5 : // 医疗器械
        case 24 : // 其他
          switch (itemType) {
            case 'salePrice' : // 单价
            case 'totalNum' : // 总量

              rows.totalPrice = (rows.salePrice * rows.totalNum).toFixed(2)
              // if(rows.totalPrice && rows.totalNum) {
              //   rows.totalPrice = (rows.salePrice * rows.totalNum).toFixed(2)
              // }
              break;
          }
          break;
        case 23 : // 治疗理疗
        case 25 : // 套餐
          switch (itemType) {
            case 'everyDay' : // 总价
            case 'totalDay' : // 总天数
              rows.totalNum = (rows.everyDay || 1) * (rows.totalDay || 1)
              if(rows.totalPrice && rows.totalNum) {
                rows.totalPrice = (rows.salePrice * rows.totalNum).toFixed(2)
              }
              break;

            case 'salePrice' : // 单价
            case 'totalNum' : // 总量
              // if(rows.totalPrice && rows.totalNum) {
              rows.totalPrice = (rows.salePrice * rows.totalNum).toFixed(2)
              // }
              break;
          }
          break;
      }
    },
    changeExamIn(e,index,rows) {
      let findIndex = rows.drugSalePojos.findIndex(item=>item.unitName === e)
      if(findIndex !== -1) {
        rows.salePrice = Number(rows.drugSalePojos[findIndex].drugSalePrice)
        rows.totalPrice = (Number(rows.drugSalePojos[findIndex].drugSalePrice) * Number(rows.totalNum)).toFixed(2)
      }
    },
    setExamInUnit(drugSalePojos,index) {
      console.log('set',drugSalePojos,index)
    },
    handleSelectExamDrug(e) {
      // 数据转换
      let rows = {
        // 诊疗项目id
        itemId: e.itemId,
        // 诊疗项目id
        diagnosisItemId : e.itemId,
        // 诊疗项目名称
        itemName : e.itemName,
        // 诊疗项目类型
        itemType : e.type,
        type : e.type,
        typeDesc : e.typeDesc,
        // 每天次数
        everyDay : '',
        // 每天次数单位
        everyDayUnit : e.unit,
        // 总天数
        totalDay : 1,
        // 总次数
        totalNum: 1,
        // 单价
        salePrice:  Number(e.sellPrice) || 0,
        // 单价单位
        totalTimesUnit: e.unit,
        drugSalePojos: e.drugSalePojos || [],
        // 销售单位
        saleUnit: e.unit,
        // 总价格
        totalPrice: Number(e.sellPrice) || 0,
        // 备注
        remarks : '',
      }
      let itemsToAdd = this.diagnosisExamList.items.some(itemA => itemA.itemId === rows.itemId);
      if(!itemsToAdd) {
        this.diagnosisExamList.items.push(rows)
      }
    },
    async querySearchExamDrug(e,cb) {
      let param = {
        'keyword' : e || ''
      }
      let res = await this.$api.outPatient.getExamSearch(param)
      if(res && res.length > 0){
        // 第一项添加
        res.push({ isHeader: true, label: '' })
        cb(res)
      }else {
        cb([])
      }
    },
    handleCloseSelect(item,index) {
      this.selectList.splice(index,1)
    },
    // 获取检查治疗项
    getHospitalExamList (type) {
      this.$api.clinicManagement.examList(this.examQuery).then(res => {
        console.log(res)
        this.examListAll = res || [];
        if(this.examListAll.length < 1) {
          return this.$message.error('暂无诊疗项目')
        }
        if (type) {
          this.oneTreeIndex = this.examListAll.findIndex(e=>e.type === type)
        }
        // 二级树
        this.twoTreeRow = res[this.oneTreeIndex].subCategory
        // 内容
        this.contentTree = this.twoTreeRow [this.twoTreeIndex].hospitalFeeItemsVOList
      });
    },
    // 诊疗项目选择  点击一级树
    handleOneTree(row,index) {
      console.log(row)
      console.log(row.subCategory)
      this.twoTreeRow = row.subCategory
      this.oneTreeIndex = index
      if (this.twoTreeRow) {
        // 二级树 默认选择第0项
        this.contentTree = this.twoTreeRow[0].hospitalFeeItemsVOList
      } else {
        this.contentTree = []
      }
      this.twoTreeIndex = 0
    },
    handleTowTree(row,index) {
      if (row.hospitalFeeItemsVOList) {
        this.contentTree = row.hospitalFeeItemsVOList
      } else {
        this.contentTree = []
      }
      this.twoTreeIndex = index
    },
    splitArrayIntoTwo(arr) {
      if (arr) {
        const length = arr.length;
        const middleIndex = Math.ceil(length / 2);
        const firstHalf = arr.slice(0, middleIndex);
        const secondHalf = arr.slice(middleIndex);
        return [firstHalf, secondHalf];
      }
      return [0, 0]
    },
    // 选择检查治疗项
    checkExam () {
      let selectList = [];
      // 数据转换
      this.selectList.forEach((item)=>{
        console.log(item)
        selectList.push({
          // 诊疗项目id
          itemId: item.itemId,
          // 诊疗项目id
          diagnosisItemId : item.itemId,
          // 诊疗项目名称
          itemName : item.itemName,
          // 诊疗项目类型
          itemType : item.type,
          type : item.type,
          typeDesc : item.typeDesc,
          // 每天次数
          everyDay : '',
          // 每天次数单位
          everyDayUnit : item.unit,
          // 总天数
          totalDay : 1,
          // 总次数
          totalNum: 1,
          // 单价
          salePrice:  Number(item.sellPrice) || 0,
          // 单价单位
          totalTimesUnit: item.unit,
          drugSalePojos: item.drugSalePojos || [],
          // 销售单位
          saleUnit: item.unit,
          // 总价格
          totalPrice: Number(item.sellPrice) || 0,
          // 备注
          remarks : '',
        })
      })
      // 创建一个新数组，包含multipleSelection中在multipleSelectionCopy中找不到的项
      let itemsToAdd = selectList.filter(itemB => !this.diagnosisExamList.items.some(itemA => itemA.itemId === itemB.itemId));
      // 新增
      this.diagnosisExamList.items = [...this.diagnosisExamList.items,...itemsToAdd]
      console.log(this.diagnosisExamList.items)
      this.cancelExam()
    },
    cancelExam () {
      this.selectList = [];
      this.examDialogVisible = false;
    },
  },
  directives: {
    autocompleteScroll
  },
  mounted () {
    // this.getDoctor();
    this.initDrug();
    this.getExamAll();
    this.getHospitalConfig();
    this.getDoctorList()
    this.getChargesConfig()
    this.getSellPriceUpdate()
  },
  computed: {
    wrapHeight () {
      return `${this.$store.state.global.windowHeight - 122}px`;
    },
    actualReceivableAmt () {
      return BN(this.totalAmt).minus(this.totalDiscount).toFixed(2);
    },
    // 三项应收金额
    totalAmt () {
      let result = BN(this.scriptAmt);
      if (this.hasExam) result = BN(result).plus(this.examAmt);
      result = BN(result).plus(this.examListAmt);
      if (this.hasAddition) result = BN(result).plus(this.addtionAmt);
      return BN(result).toFixed(2);
    },
    // 所有优惠价格
    totalDiscount () {
      const wipeAmt = this.wipeAmt || 0;
      const couponAmt = this.couponAmt || 0;
      let result = this.offer;
      if (REG_AMT.test(wipeAmt)) result = BN(result).plus(wipeAmt);
      if (REG_AMT.test(couponAmt)) result = BN(result).plus(couponAmt);
      return BN(result).toFixed(2);
    },
    // 处方应收
    scriptAmt () {
      const orderPrescription = cloneDeep(this.orderPrescription);
      orderPrescription.items = orderPrescription.items.filter(item => item.drugId);
      const sub = orderPrescription.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        const dosage = Number(b.dosage);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.salePrice).multipliedBy(b.dosage).toFixed(2);
        }
        return a + Number(result);
      }, 0);
      // 赋值给orderPrescription
      this.orderPrescription.receivableAmt = sub;
      return sub;
    },
    // 药品实付金额
    orderPrescriptionTotal () {
      const subMeter = Number(this.scriptAmt);
      const discountAmt = Number(this.orderPrescription.discountAmt);
      if (subMeter < discountAmt) return "0.00";
      if (!discountAmt || isNaN(discountAmt)) return BN(this.scriptAmt).toFixed(2);
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    addtionAmt () {
      const sub = this.orderAddition.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        let result = 0;
        if (salePrice && !isNaN(salePrice)) {
          result = salePrice;
        }
        return a + result;
      }, 0);
      // 赋值给orderPrescription
      this.orderAddition.receivableAmt = BN(sub).toFixed(2);
      return sub;
    },
    addtionTotal () {
      const subMeter = Number(this.addtionAmt);
      const discountAmt = Number(this.orderAddition.discountAmt);
      if (subMeter < discountAmt) return "0.00";
      if (!discountAmt || isNaN(discountAmt)) return subMeter;
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    // 检查项合计总价
    examAmt () {
      const sub = this.orderExam.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        const dosage = Number(b.count);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.salePrice).multipliedBy(b.count).toFixed(2);
        }
        return a + Number(result);
      }, 0);
      // 赋值给 orderExam
      this.orderExam.receivableAmt = sub;
      return sub;
    },
    // 检查治疗项实收
    examTotal () {
      const subMeter = Number(this.examAmt);
      const discountAmt = Number(this.orderExam.discountAmt);
      if (subMeter < discountAmt) return "0.00";
      if (!discountAmt || isNaN(discountAmt)) return BN(subMeter).toFixed(2);
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    // 三项优惠金额
    offer () {
      const orderScript = this.orderPrescription.discountAmt || 0;
      const addScript = this.orderAddition.discountAmt || 0;
      const examScript = this.orderExam.discountAmt || 0;
      const diagnosisExamScript = this.diagnosisExamList.discountAmt || 0;
      let result = 0;
      if (REG_AMT.test(orderScript)) result = BN(result).plus(orderScript);
      if (REG_AMT.test(addScript) && this.hasAddition) result = BN(result).plus(addScript);
      if (REG_AMT.test(examScript) && this.hasExam) result = BN(result).plus(examScript);
      if (REG_AMT.test(diagnosisExamScript)) result = BN(result).plus(diagnosisExamScript);
      return BN(result).toFixed(2);
    },
    // 优惠券优惠金额
    couponAmt () {
      if (this.hasCoupon && this.couponType !== 0) {
        if (this.couponType === 1) {
          const discount = 1 - this.couponVal.discount;
          return BN(this.totalAmt).minus(this.offer).multipliedBy(discount).toFixed(2);
        }
        if (this.couponType === 2) {
          const price = BN(this.totalAmt).minus(this.offer);
          if (price >= Number(this.couponVal.paramValue1)) {
            return this.couponVal.paramValue2;
          }
          return "0.00";
        }
      }
      return "0.00";
    },
    // 当表单没有填入时按钮不能点击
    confirmDisabled () {
      const hasPre = this.orderPrescription.items.some(item => item.drugId);
      const hasExam = this.orderExam.items.some(item => item.examId);
      const hasDiagnosisExam = this.diagnosisExamList.items.some(item => item.itemId);
      const hasAdd = this.orderAddition.items.some(item => item.amtName);
      return !hasPre && !hasExam && !hasAdd && !hasDiagnosisExam;
    },
    // 是否打印小票
    isPrint: {
      get () {
        return this.$store.state.global.printConfig.isReceipt;
      },
      set (val) {
        this.$store.commit("changeReceipt", val);
      }
    },
    isHiSuccess () {
      return this.$store.state.global.isHiSuccess
    },
    countInfo () {
      return this.$store.state.global.countInfo
    },
    hasDiaanosisExam() {
      console.log(this.diagnosisExamList && this.diagnosisExamList.length > 0)
      return this.diagnosisExamList && this.diagnosisExamList.length > 0
    },
    // // 诊疗项目小计
    // examListTotal() {
    //   let sum = this.diagnosisExamList.items.reduce((cur,item,index)=>{
    //     return cur + Number(item.totalPrice)
    //   },0)
    //   return Number(sum).toFixed(2)
    // },
    // examListAmt() {
    //   const sub = this.diagnosisExamList.items.reduce((a, b) => {
    //     const salePrice = Number(b.salePrice);
    //     const dosage = Number(b.count);
    //     let result = 0;
    //     if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
    //       result = BN(b.salePrice).multipliedBy(b.count).toFixed(2);
    //     }
    //     return a + Number(result);
    //   }, 0);
    //   // 赋值给 orderExam
    //   this.diagnosisExamList.receivableAmt = sub;
    //   return sub;
    // },
    // 检查项合计总价
    examListAmt () {
      const sub = this.diagnosisExamList.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        const dosage = Number(b.totalNum);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.salePrice).multipliedBy(b.totalNum).toFixed(2);
        }
        return a + Number(result);
      }, 0);
      // 赋值给 orderExam
      this.diagnosisExamList.receivableAmt = sub;
      return sub;
    },
    // 检查治疗项实收
    examListTotal () {
      const subMeter = Number(this.examListAmt);
      const discountAmt = Number(this.diagnosisExamList.discountAmt);
      if (subMeter < discountAmt) return "0.00";
      if (!discountAmt || isNaN(discountAmt)) return BN(subMeter).toFixed(2);
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    selectNum() {
      let num = 0
      this.selectList.forEach(item=>{
        this.contentTree.forEach(ite=>{
          if(item.itemId === ite.itemId) {
            num++
          }
        })
      })
      return num
    }
  }
};
